import LinkifyJs from "linkify-react";
import { Opts } from "linkifyjs";
import React from "react";

const isValidLinkUrl = (target: string): boolean => {
    let url: URL;
    try {
        url = new URL(target);
    } catch (e) {
        return false;
    }

    if (url.protocol !== "http:" && url.protocol !== "https:") {
        return false;
    }

    const hostname = (url.hostname || "").toLowerCase();

    if (!hostname) {
        return false;
    }

    if (
        hostname === "localhost" ||
        hostname === "127.0.0.1" ||
        hostname === "0.0.0.0" ||
        hostname === "::1"
    ) {
        return false;
    }

    if (hostname.endsWith(".local")) {
        return false;
    }

    if (!hostname.includes(".")) {
        return false;
    }

    return true;
};

type Props = {
    children: React.ReactNode;
    as?: string;
    options?: Opts;
};

const defaultOpts: Opts = {
    target: "_blank",
    rel: "noopener noreferrer",
    validate: {
        url: isValidLinkUrl,
    },
};

const Linkify = ({ as = "span", options = {}, children }: Props) => (
    <LinkifyJs as={as} options={{ ...defaultOpts, ...options }}>
        {children}
    </LinkifyJs>
);

export default Linkify;
